import _ from "@lodash";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import React from "react";
import EmpresaPessoaApp from "../EmpresaPessoa/EmpresaPessoaApp";

class EmpresaPacienteApp extends XAPPComponent {

    render() {
        var { xappRouteParams, label = "Pacientes" } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        return (
            <React.Fragment>
                <EmpresaPessoaApp
                    xappRouteParams={xappRouteParams}
                    isGestor={false}
                    target="spvwempresapessoapaciente"
                    customFields={"paciente"}
                    {...this.props}
                    defaultTipo={[3]}
                    label={label}
                />
            </React.Fragment>
        );
    }
}


export default EmpresaPacienteApp;
